import styled, { css } from 'styled-components';
import { addCssPrefixTo } from '../../utils';

export const StyledPage = styled.div.attrs({
  className: addCssPrefixTo('PAGE'),
})`
  background: ${({ theme }) => theme.color.primaryBackground};
  color: ${({ theme }) => theme.color.text};
  padding-bottom: 10px;
  min-height: calc(100dvh - 48px);
`;

export const PageContent = styled.div`
  ${props =>
    props.hasImage &&
    css`
      margin-top: unset;
    `}
  ${props =>
    props.container &&
    css`
      position: relative;
      min-height: 320px;

      ${props =>
        props.showFooter &&
        css`
          padding-bottom: 58px;
        `}
    `}
`;
